export const COMMON_CODE_MUTATION = {
  MOBILE_STATION: "MOBILE_STATION_COMMON_CODE_MUTATION",
  PHONE_AREA: "PHONE_AREA_COMMON_CODE_MUTATION",
  EMAIL_VENDOR: "EMAIL_VENDOR_COMMON_CODE_MUTATION",
  CURRENCY: "CURRENCY_COMMON_CODE_MUTATION",
  PAGE_RANGE: "PAGE_RANGE_COMMON_CODE_MUTATION",
  QUANTITY: "QUANTITY_COMMON_CODE_MUTATION",
  BANK_CODE: "BANK_COMMON_CODE_MUTATION",
};
